/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-11 16:11:07
 *
 *******************************************************/
// @flow

import React from 'react';
export function IntegrationIcon(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 9.59961C11.3545 9.59961 10.7705 9.85881 10.3385 10.2748L6.3705 8.29001C6.3825 8.19401 6.4001 8.09961 6.4001 7.99961C6.4001 7.89961 6.3825 7.80521 6.3705 7.70921L10.3385 5.72441C10.7705 6.14041 11.3545 6.39961 12.0001 6.39961C13.3233 6.39961 14.4001 5.32281 14.4001 3.99961C14.4001 2.67641 13.3233 1.59961 12.0001 1.59961C10.6769 1.59961 9.6001 2.67641 9.6001 3.99961C9.6001 4.09961 9.6177 4.19401 9.6297 4.29001L5.6617 6.27481C5.2297 5.85881 4.6457 5.59961 4.0001 5.59961C2.6769 5.59961 1.6001 6.67641 1.6001 7.99961C1.6001 9.32281 2.6769 10.3996 4.0001 10.3996C4.6457 10.3996 5.2297 10.1404 5.6617 9.72441L9.6297 11.7092C9.6177 11.8052 9.6001 11.8996 9.6001 11.9996C9.6001 13.3228 10.6769 14.3996 12.0001 14.3996C13.3233 14.3996 14.4001 13.3228 14.4001 11.9996C14.4001 10.6764 13.3233 9.59961 12.0001 9.59961Z"
        fill="#8C9196"
      />
    </svg>
  );
}
